import React, { useState, useEffect, useRef, useContext, useCallback } from "react";
import { Button, Dialog, Toast } from "primereact";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";

import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../Base/Hooks/useForm";
import Loader from "../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../Base/Services/ToastService";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { getLabel } from "../../../Base/Services/Language/LanguageService";

import { getEstadosCotizaciones } from "../../../API/Global/Status/StatusRequests";
import { EditarYarnSynthetic, getCalibres, getCross, getEfectos, getLoster, getRecycled, getTypes, getTypesPoly, getYarn, GuardarYarnSinthetic, ObtenerSiguienteCorrelativoS } from "../../../API/Desarrollo/DesarrolloRequest";
import { Checkbox } from "primereact/checkbox";

const YarnSynteticCRUD = ({
  dialog,
  setDialog,
  selected,
  setSelected,
  modo,
  getInfo,
}) => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [types, setTypes] = useState([]);
  const [efectos, setEfectos] = useState([]);
  const [calibres, setCalibres] = useState([]);
  const [loster, setLoster] = useState([]);
  const [recycled, setRecycled] = useState([]);
  const [cross, setCross] = useState([]);
  const [yarnSpandex, setYarnSpandex] = useState([]);
  const [typesP, setTypesP] = useState([]);
  const [titulo, setTitulo] = useState(null);
  const [button, setButton] = useState(null);
  const [covering, setCovering] = useState(false);
  

  const initialValues = {
    IdYarnTitle: -1,
    IdStatus: selected ? selected?.IdStatus : 3706,
    IdStyleCategory: 2,
  };

  const ply = [
    { IdPlay: 1, Ply: "1" },   
    { IdPlay: 2, Ply: "2" },   
  ]  

  const origen = [
    { IdOrigin: 1, Origin: "CAFTA" },   
    { IdOrigin: 2, Origin: "NO CAFTA" },   
  ]  

  const heat = [
    { IdHeat: 1, HeatL: "1H" },   
    { IdHeat: 2, HeatL: "2H" },   
  ]  

  const tipoTejido = [
    { IdTipoTejido: 1, TipoTejido: "CIRCULAR" },   
    { IdTipoTejido: 2, TipoTejido: "WARP" },   
  ]  


  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const estadosTempo = await getEstadosCotizaciones();
    setEstados(estadosTempo);

    const calibresTempo = await getCalibres()
    setCalibres(calibresTempo.filter(i => i.IdStyleCategory === 2))

    const calibreInicial = modo === "Crear" ? calibresTempo : calibresTempo.find((e) => e.IdCalibre === selected?.IdCalibre);

    const typesTempo = await getTypes()
    let a = typesTempo?.filter(i => i.IdStyeleCategory === 2)
    setTypes(a)
    const typeInicial = modo === "Crear" ? a : a.find((e) => e.IdType === selected?.IdType);

    const efectosTempo = await getEfectos()
    setEfectos(efectosTempo.filter(i => i.IdStyleCategory === 2))
    const efectoInicial = modo === "Crear" ? efectosTempo : efectosTempo.find((e) => e.IdEfecto === selected?.IdEfecto);

    const losterTempo = await getLoster()
    setLoster(losterTempo)
    const losterInicial = modo === "Crear" ? losterTempo : losterTempo.find((e) => e.IdLoster === selected?.IdLoster);

    const recycledTempo = await getRecycled()
    setRecycled(recycledTempo)
    const recycleInicial = modo === "Crear" ? recycledTempo : recycledTempo.find((e) => e.IdRecycle === selected?.IdRecycled);

    const crossTempo = await getCross()
    setCross(crossTempo)
    const crossInicial = modo === "Crear" ? crossTempo : crossTempo.find((e) => e.IdCross === selected?.IdCross);

    const typesP = await getTypesPoly()
    setTypesP(typesP)
    const typesPInitial = modo === "Crear" ? typesP : typesP.find((e) => e.IdTypePoly === selected?.IdTypePoly);

    const resp = await ObtenerSiguienteCorrelativoS()
    const corretativo = modo === "Crear" ? resp[0]?.Correlativo : selected?.Correlativo;

    const yarnSpandexTempo = await getYarn()
    setYarnSpandex(yarnSpandexTempo.filter(i=> i.Spandex === true))

    const yarnInicial = modo === "Crear" ? yarnSpandexTempo : yarnSpandexTempo.find((e) => e.IdYarnTitle === selected?.IdYarnCovering);

    
    if(selected?.IdYarnCovering) {
      setCovering(true)
    }
  

    setValues({
      ...selected,
      IdYarnTitle: selected ? selected?.IdYarnTitle : -1,
      Correlativo: corretativo,
      Calibre: calibreInicial?.Calibre,
      IdCalibre: calibreInicial?.IdCalibre,
      Type: typeInicial?.Type,
      IdType: typeInicial?.IdType,
      Efecto: efectoInicial?.Efecto,

      IdLoster: losterInicial?.IdLoster,
      Loster: losterInicial?.Loster,

      IdRecycle: recycleInicial?.IdRecycle,
      Recycled: recycleInicial?.Recycled,

      IdCross: crossInicial?.IdCross,
      CrossSection: crossInicial?.CrossSection,

      IdYarnCovering: yarnInicial?.IdYarnTitle,
      YarnCovering: yarnInicial?.Yarn,

      IdTypePoly: typesPInitial?.IdTypePoly,
      TypePoly: typesPInitial?.TypePoly,

      IdEfecto: efectoInicial?.IdEfecto,
      IdStyleCategory: 2,

      Ply: selected?.Play ? selected?.Play : null,
      IdOrigin: selected?.IdOrigin ? selected?.IdOrigin : null,
      Origin: selected?.Origin ? selected?.Origin : null,

      IdTipoTejido: selected?.IdTipoTejido ? selected?.IdTipoTejido : null,
      TipoTejido: selected?.TipoTejido ? selected?.TipoTejido : null,

      HeatL: selected?.Heat ? selected?.Heat : null,
      Denier : selected?.Denier ? selected?.Denier : null,
    });
    setLoading(false);
  };

  const onHide = () => {
    setDialog(false);
    setSelected(null);
  };

  const verificarInfo = () => {
    let error = {};

    if (!values.Filamentos) {
      error.Filamentos = true;
      error.error = true;
    }

    if(covering){
      if (!values.YarnCovering) {
        error.IdYarnCovering = true;
        error.error = true;
      }
    }

    if (modo === "Crear") {
      if (!values.Type) {
        error.IdType = true;
        error.error = true;
      }
      if (!values.Ply) {
        error.IdPlay = true;
        error.error = true;
      }
      if (!values.Calibre) {
        error.IdCalibre = true;
        error.error = true;
      }
      // if(values?.Loster){
      //   if (!values.Efecto) {
      //     error.IdEfecto = true;
      //     error.error = true;
      //   }
      // }
      // if (!values.Recycled) {
      //   error.IdRecycled = true;
      //   error.error = true;
      // }
      // if (!values.CrossSection && !covering) {
      //   error.IdCross = true;
      //   error.error = true;
      // }
      if (!values.HeatL && !covering) {
        error.IdHeat = true;
        error.error = true;
      }
      // if (!values.TipoTejido) {
      //   error.IdTipoTejido = true;
      //   error.error = true;
      // }
      if (!values.Origin && !covering) {
        error.IdOrigin = true;
        error.error = true;
      }


    } else {
      if (!values.Type) {
        error.IdType = true;
        error.error = true;
      }
      if (!values.Ply) {
        error.IdPlay = true;
        error.error = true;
      }
      if (!values.Calibre) {
        error.IdCalibre = true;
        error.error = true;
      }
      // if(values?.Loster){
      //   if (!values.Efecto) {
      //     error.IdEfecto = true;
      //     error.error = true;
      //   }
      // }
      // if (!values.Recycled) {
      //   error.IdRecycled = true;
      //   error.error = true;
      // }
      // if (!values.CrossSection && !covering) {
      //   error.IdCross = true;
      //   error.error = true;
      // }
      if (!values.HeatL && !covering) {
        error.IdHeat = true;
        error.error = true;
      }
      // if (!values.TipoTejido) {
      //   error.IdTipoTejido = true;
      //   error.error = true;
      // }
      if (!values.Origin && !covering) {
        error.IdOrigin = true;
        error.error = true;
      }
    }
    
    setError(error);
    return error;
  };

  const agregarDatos = async () => {
    const e = verificarInfo();
    if (!e.error) {
      let Datos

      if (covering){
        Datos = {
          IdYarnTitle: values?.IdYarnTitle,
          IdStyleCategory: 2,
          Yarn: values?.Yarn,
          IdType: values?.IdType || values?.Type?.IdType,
          Play: values?.Play || values?.Ply?.IdPlay,
          IdCalibre: values?.IdCalibre || values?.Calibre?.IdCalibre,
          Filamentos: values?.Filamentos,
          IdLoster: values?.IdLoster || values?.Loster?.IdLoster,
          IdUserCreate: userAuth?.idUser,
          IdUserEdit: userAuth?.idUser,
          IdYarnCovering: values?.IdYarnCovering || values?.YarnCovering?.IdYarnTitle,
        };
      }else{
        Datos = {
          IdYarnTitle: values?.IdYarnTitle,
          IdStyleCategory: 2,
          Yarn: values?.Yarn,
          IdType: values?.Type?.IdType || values?.IdType,
          Play: values?.Ply?.IdPlay || values?.Play,
          IdCalibre: values?.Calibre?.IdCalibre ||values?.IdCalibre,
          Filamentos: values?.Filamentos,
          IdLoster: values?.Loster?.IdLoster || values?.IdLoster,
          IdEfecto: values?.Efecto?.IdEfecto || values?.IdEfecto,
          IdRecycled: values?.Recycled?.IdRecycle || values?.IdRecycle,
          IdCross: values?.CrossSection?.IdCross || values?.IdCross,
          IdTypePoly: values?.TypePoly?.IdTypePoly || values?.IdTypePoly,
          Heat: values?.HeatL?.HeatL ||  values?.Heat,
          IdOrigin: values?.Origin?.IdOrigin || values?.IdOrigin,
          Origin: values?.Origin?.Origin ||  values?.Origin,
          IdUserCreate: userAuth?.idUser,
          IdUserEdit: userAuth?.idUser,
          IdTipoTejido: values?.TipoTejido?.IdTipoTejido || values?.IdTipoTejido,
          TipoTejido: values?.TipoTejido?.TipoTejido ||  values?.TipoTejido,
        };
      }


      setLoading(true);
      if (values?.IdYarnTitle > 0) {
        const respuesta = await EditarYarnSynthetic(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
          setTimeout(() => {
            // onHide();
            obtenerInformacion(respuesta[0]?.IdYarnTitle)
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      } else {
        const respuesta = await GuardarYarnSinthetic(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
          setTimeout(() => {
            // onHide();
            obtenerInformacion(respuesta[0]?.IdYarnTitle)
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      }
    }else{
      toastShow(toast, "error", "Error", 'Complete los campos requeridos.');
    }
  };

  const obtenerInformacion = async (IdYarnTitle) => {
    setLoading(true)

    const encTempo = await getYarn()
    setTitulo('Editar Yarn Synthetic')

    let encabezadoTempo = encTempo?.filter(i => i.IdYarnTitle === IdYarnTitle)

    if(encabezadoTempo[0]?.IdYarnCovering){
      setValues({
        ...encabezadoTempo,
        IdYarnTitle: encabezadoTempo[0]?.IdYarnTitle,
        Yarn: encabezadoTempo[0].Yarn,
        IdType: encabezadoTempo[0]?.IdType,
        Type: encabezadoTempo[0]?.Type,
        Calibre: encabezadoTempo[0]?.Calibre,
        IdCalibre: encabezadoTempo[0]?.IdCalibre,
        Play: encabezadoTempo[0]?.Play,
        Ply: encabezadoTempo[0]?.Play,
        Filamentos: encabezadoTempo[0]?.Filamentos,
        IdLoster: encabezadoTempo[0]?.IdLoster,
        Loster: encabezadoTempo[0]?.Loster,
        IdPlay: encabezadoTempo[0]?.Play === 1 ? 1 : 2,
        IdYarnCovering: encabezadoTempo[0]?.IdYarnCovering,
        YarnCovering: encabezadoTempo[0]?.YarnCovering,
      })
    }else{
      setValues({
        ...encabezadoTempo,
        IdYarnTitle: encabezadoTempo[0]?.IdYarnTitle,
        Calibre: encabezadoTempo[0]?.Calibre,
        IdCalibre: encabezadoTempo[0]?.IdCalibre,
        Play: encabezadoTempo[0]?.Play,
        Ply: encabezadoTempo[0]?.Play,
        IdType: encabezadoTempo[0]?.IdType,
        Type: encabezadoTempo[0]?.Type,
        IdOrigin: encabezadoTempo[0]?.IdOrigin,
        Origin: encabezadoTempo[0]?.Origin,
        IdTipoTejido: encabezadoTempo[0]?.IdTipoTejido,
        TipoTejido: encabezadoTempo[0]?.TipoTejido,
        Efecto: encabezadoTempo[0]?.Efecto,
        IdEfecto: encabezadoTempo[0]?.IdEfecto,
        Yarn: encabezadoTempo[0].Yarn,
        Filamentos: encabezadoTempo[0]?.Filamentos,
        IdLoster: encabezadoTempo[0]?.IdLoster,
        Loster: encabezadoTempo[0]?.Loster,
        IdRecycle: encabezadoTempo[0]?.IdRecycle,
        Recycled: encabezadoTempo[0]?.Recycled,
        IdCross: encabezadoTempo[0]?.IdCross,
        CrossSection: encabezadoTempo[0]?.CrossSection,
        Heat: encabezadoTempo[0]?.Heat,
        HeatL: encabezadoTempo[0]?.Heat,
        IdHeat: encabezadoTempo[0]?.Heat === '1H' ? 1 : 2,
        IdPlay: encabezadoTempo[0]?.Play === 1 ? 1 : 2,
        // IdYarnCovering: encabezadoTempo[0]?.IdYarnCovering,
        // YarnCovering: encabezadoTempo[0]?.YarnCovering,
      })
    }


    setLoading(false)
  }
  
  const duplicarCotizacion = async(encabezado) => {
    if(encabezado?.IdYarnTitle > 0){
      setLoading(true)
      const resp = await ObtenerSiguienteCorrelativoS()

      setValues({
        ...values,
        IdYarnTitle: -1,
        Correlativo: resp[0]?.Correlativo,
        IdTypePoly: encabezado[0]?.IdTypePoly,
        TypePoly: encabezado[0]?.TypePoly,
      })

      setTitulo('Agregar Yarn Synthetic')
      setButton('Guardar')
      
      setTimeout(() => {        
        toastShow(toast, "success", "Nuevo", 'Información duplicada.');
        setLoading(false)
      }, 700);
      
    }else{
      toastShow(toast, "error", "Error", 'Guarde la cotización antes de duplicarla.');
    }
  }

  const DialogFooter = (
    <React.Fragment>
      <Button
        label={getLabel(baseLang, "cancelar", config.language)}
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={button ? button : modo === "Crear" ? `${getLabel(baseLang, "btnGuardar", config.language)}` : `${getLabel(baseLang, "btnEditar", config.language)}`}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarDatos}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (dialog) {
      getValoresIniciales();
    }
  }, [dialog]);

  const dialogTitle = modo === "Crear" ? `${getLabel(baseLang, "Agregar Yarn Synthetic", config.language)}` : `${getLabel(baseLang, "Editar Yarn Synthetic", config.language)}`;

  const construirYarnText = useCallback(() => {
    let Type = values?.Type?.Type || values?.Type || '';
    let Play = values?.Ply?.Ply || values?.Play || '';
    let IdDenier = values?.Calibre?.Calibre || values?.Calibre || '';
    let Filamentos = values?.Filamentos || '';
    let Loster = values?.Loster?.Loster || values?.Loster || '';
    let TypePoly = values?.TypePoly?.TypePoly || values?.TypePoly || '';
    let Efecto = values?.Efecto?.Efecto || values?.Efecto || '';
    let Recycled = values?.Recycled?.Recycled || values?.Recycled || '';
    let Cross = values?.CrossSection?.CrossSection || values?.CrossSection || '';
    let Heat = values?.HeatL?.HeatL || values?.Heat || '';
    // let IdOrigin = values?.Origin?.IdOrigin || values?.IdOrigin || '';
    // let Origin = IdOrigin === 1 ? '01' : IdOrigin === 2 ? '02' : '';

        let Origin

    // let Origin = values?.Origin?.IdOrigin === 1 || values?.IdOrigin === 1 ? "01"
    // : values?.Origin?.IdOrigin === 2 || values?.IdOrigin === 2 ? "02" : "";
    // console.log(values?.Origin?.IdOrigin)

    if(values?.Origin?.IdOrigin === 1){
      Origin = '01'
    }else{
      if(values?.IdOrigin === 1 && !values?.Origin?.IdOrigin){
        Origin = '01'
      }else{
        Origin = '02'
      }
    }
    let TipoTejido = values?.TipoTejido?.TipoTejido || values?.TipoTejido || '';


    let Yarn = [
      Type,
      Play && IdDenier && Filamentos ? `${Play}/${IdDenier}/${Filamentos}` : '',
      Loster,
      TypePoly,
      Recycled,
      Efecto,
      Cross,
      Heat,
      TipoTejido,
      Origin
    ]
      .filter(Boolean)
      .join(' ');

    if (values.Yarn !== Yarn) {
      setValues((prevValues) => ({
        ...prevValues,
        Yarn
      }));
    }
  }, [values, setValues, covering]); 

  const construirYarnTextCovering = useCallback(() => {
    let Type = values?.Type?.Type || values?.Type || '';
    let Play = values?.Ply?.Ply || values?.Play || '';
    let IdDenier = values?.Calibre?.Calibre || values?.Calibre || '';
    let Filamentos = values?.Filamentos || '';
    let Loster = values?.Loster?.Loster || values?.Loster || '';
    let YarnCovering = values?.YarnCovering?.Yarn || values?.YarnCovering

    let Yarn = [
      Type,
      Play && IdDenier && Filamentos ? `${Play}/${IdDenier}/${Filamentos}` : '',
      Loster,
      YarnCovering ? `COVERING ${YarnCovering}` : ''
    ]
      .filter(Boolean)
      .join(' ');

    if (values.Yarn !== Yarn) {
      setValues((prevValues) => ({
        ...prevValues,
        Yarn
      }));
    }
  }, [values, setValues, covering]); 

  useEffect(() => {
    if(covering){
      construirYarnTextCovering()
    }else{
      construirYarnText();
    }
  }, [values, construirYarnText]);

  return (
    <div>
      <Dialog
        visible={dialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        style={{ width: '65%'}}
      >
        <Toast ref={toast} style={{ zIndex: 50000 }} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center mx-2">
              <h3 className="me-3">{titulo ? titulo : dialogTitle}</h3>
              {values?.Correlativo && (
                <h2><strong>{values?.Correlativo}</strong></h2>
              )}

              
              <div className="ms-3 d-flex align-items-center" style={{marginTop: -10}}>
                <Checkbox 
                  inputId="coveringCheckbox" 
                  checked={covering} 
                  onChange={(e) => setCovering(e.checked)} 
                />
                <label htmlFor="coveringCheckbox" className="ms-2">Covering</label>
              </div>
            </div>

            <div className="mx-2">

              <div className="d-flex gap-2 mx-2">
                <div className="field mt-2">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"Type"}
                      value={values.Type}
                      items={types}
                      field={"Type"}
                      label={getLabel(baseLang, "Type", config.language)}
                      handleInputChange={handleInputChange}
                      className={error.IdType ? "p-invalid" : ""}
                    />
                  </span>
                </div>

                <div className="field mt-2">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"Ply"}
                      value={values.Ply}
                      items={ply}
                      field={"Ply"}
                      label={getLabel(baseLang, "Ply", config.language)}
                      handleInputChange={handleInputChange}
                      className={error.IdPlay ? "p-invalid" : ""}
                    />
                  </span>
                </div>

                <div className="field mt-2">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"Calibre"}
                      value={values.Calibre}
                      items={calibres}
                      field={"Calibre"}
                      label={getLabel(baseLang, "Denier", config.language)}
                      handleInputChange={handleInputChange}
                      className={error.IdCalibre ? "p-invalid" : ""}
                    />
                  </span>
                </div>

                <div className="field mt-2" style={{width: 230}}>
                  <span className="p-float-label">
                    <InputNumber
                      name="Filamentos"
                      value={values.Filamentos}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      className={error.Filamentos ? "p-invalid" : ""}
                    />
                    <label htmlFor="Filamentos">{getLabel(baseLang, "Filament", config.language)}</label>
                  </span>
                </div>

                <div className="field mt-2">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"Loster"}
                      value={values.Loster}
                      items={loster}
                      field={"Loster"}
                      label={getLabel(baseLang, "Luster", config.language)}
                      handleInputChange={handleInputChange}
                      className={error.IdLoster ? "p-invalid" : ""}
                    />
                  </span>
                </div>
              </div>


              {!covering && (
                <div className="d-flex gap-2 mx-2 mt-1">
                  <div className="field mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"TypePoly"}
                        value={values.TypePoly}
                        items={typesP}
                        field={"TypePoly"}
                        label={getLabel(baseLang, "Type Poly", config.language)}
                        handleInputChange={handleInputChange}
                        className={error.IdTypePoly ? "p-invalid" : ""}
                      />
                    </span>
                  </div>

                  <div className="field mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Recycled"}
                        value={values.Recycled}
                        items={recycled}
                        field={"Recycled"}
                        label={getLabel(baseLang, "Recycled", config.language)}
                        handleInputChange={handleInputChange}
                        className={error.IdRecycled ? "p-invalid" : ""}
                      />
                    </span>
                  </div>

                  <div className="field mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Efecto"}
                        value={values.Efecto}
                        items={efectos}
                        field={"Efecto"}
                        label={getLabel(baseLang, "Efecto", config.language)}
                        handleInputChange={handleInputChange}
                        className={error.IdEfecto ? "p-invalid" : ""}
                      />
                    </span>
                  </div>

                  <div className="field mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"CrossSection"}
                        value={values.CrossSection}
                        items={cross}
                        field={"CrossSection"}
                        label={getLabel(baseLang, "Cross", config.language)}
                        handleInputChange={handleInputChange}
                        className={error.IdCross ? "p-invalid" : ""}
                      />
                    </span>
                  </div>

                  <div className="field mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"HeatL"}
                        value={values.HeatL}
                        items={heat}
                        field={"HeatL"}
                        label={getLabel(baseLang, "Heat", config.language)}
                        handleInputChange={handleInputChange}
                        className={error.IdHeat ? "p-invalid" : ""}
                      />
                    </span>
                  </div>
                </div>
              )}

              {!covering && (
                <div className="d-flex gap-2 mx-2 mt-1">
                  <div className="field mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"TipoTejido"}
                        value={values.TipoTejido}
                        items={tipoTejido}
                        field={"TipoTejido"}
                        label={getLabel(baseLang, "TipoTejido", config.language)}
                        handleInputChange={handleInputChange}
                        className={error.IdTipoTejido ? "p-invalid" : ""}
                      />
                    </span>
                  </div>

                  <div className="field mt-2" style={{width: 230}}>
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Origin"}
                        value={values.Origin}
                        items={origen}
                        field={"Origin"}
                        label={getLabel(baseLang, "Origin", config.language)}
                        handleInputChange={handleInputChange}
                        className={error.IdOrigin ? "p-invalid" : ""}
                      />
                    </span>
                  </div>

                </div>
              )}

              {covering && (
                <div className="d-flex gap-2 mx-2 mt-1">
                  <div className="field mt-2" style={{width: '39.5%'}}>
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"YarnCovering"}
                        value={values.YarnCovering}
                        items={yarnSpandex}
                        field={"Yarn"}
                        label={getLabel(baseLang, "Covering", config.language)}
                        handleInputChange={handleInputChange}
                        className={error.IdYarnCovering ? "p-invalid" : ""}
                      />
                    </span>
                  </div>
                </div>
              )}

              <div className="d-flex gap-2 mx-2 mt-4">
                <div className="field mt-2 col-12">
                  <span className="p-float-label">
                    <InputText
                      name="Yarn"
                      value={values.Yarn}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      disabled
                    />
                    <label htmlFor="Yarn">{getLabel(baseLang, "Yarn Spec", config.language)}</label>
                  </span>
                </div>
              </div>

              <div className="field mt-3 d-flex flex-end">
                <Button
                  icon="pi pi-copy"
                  type="button"
                  disabled={ (values?.IdYarnTitle <= 0)}
                  onClick={() => duplicarCotizacion(values)}
                  tooltip="Duplicar"
                  style={{ marginLeft: 1, zIndex: 999999 }}
                />
              </div>

            </div>
        
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default YarnSynteticCRUD;

